<div class="overlay3"
     (click)="onClose()"></div>

<div class="popup-wrap" [@wordDetailInOut]>
  <div class="popup-head">
    <div class="head-txt-box">문장 듣기 도움말</div>
    <a class="popup-close-btn" (click)="onClose()"></a>
  </div>

  <div class="help-body-container example-help-body-container scroll-effect"
       [style.max-height.px]="calculatedHeight">
    <div class="popup-body">
      <div class="help-txt-box">
        <div class="row">
          <div class="con">
            한국어는 하나의 단어 뒤에 조사, 접미사, 동사 및 형용사의 활용 등이 붙음으로 인하여 앞에 있는 단어의 높낮이에 영향을 끼칩니다. 즉 표제어에 제시 된 발음이 그 뒤에 어떤 음절이 붙는가에 따라서 그것의 높낮이 또한 바뀌어진다는 것입니다.
          </div>
        </div>
        <div class="row">
          <div class="con">
            그리하여 ‘문장 듣기’란에서는, 표제어가 단독으로 쓰이는 경우와 그렇지 않은 경우에 어떻게 높낮이가 달라지는가를 듣고 알게 하였습니다. 우리 한국어에서는 이 부분이 매우 중요한 것이라서 많은 이들에게 도움이 되기를 바랍니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
